import {
    Button,
    UncontrolledTooltip
} from "reactstrap";
import React, {useState} from "react";

const ArchiveButton = ({idx, elem, showArchive}) => {
    return (
        <span>

            <Button
                className="btn-link "
                color="wycena"
                data-toggle="tooltip"
                id={`archive-${idx}`}
                size="sm"
                type="button"
                onClick={(e) => {
                    showArchive(elem.id)
                }}
                aria-label={'Archiwum'}
            >
                <i className="far fa-file-archive "></i>
            </Button>
            <UncontrolledTooltip
                delay={{ show: 0, hide: 200 }}
                placement="top"
                target={`archive-${idx}`}
            >
                Archiwum
            </UncontrolledTooltip>


        </span>
    );
}
export default ArchiveButton